export default __webpack_public_path__ + "static/media/foam1.7f039ff9.jpg";